var React = require('react');

function FoodAndDrinkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M48 59V5c-6.667 2.215-10 10.882-10 26v5h10m-27-9v32m6-54v18a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V5m4 0v15m4-15v15","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

FoodAndDrinkInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = FoodAndDrinkInline;

FoodAndDrinkInline.default = FoodAndDrinkInline;
